import React from "react";

export default function Footer() {
    return (
      <div className="Footer">
        <footer>
            <span>This project was coded by Isabel Klint and is open sourced on Github.</span>
        </footer>
      </div>
    );
  }